module.exports = __webpack_public_path__ + "static/media/comment-dollar-solid.cb046648.svg";